export const EURO: string = 'EURO';